<template>
  <div>
    <Pane />
    <a-card class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="8" :md="8" :sm="24">
            <a-form-item label="拟调入部门">
              <a-select
                v-decorator="[
                  'deptId',
                  {
                    rules: [{ required: true, message: '请输入后选择！' }],
                  },
                ]"
                show-search
                :filter-option="$selectFilterOption"
                @change="onDeptChange"
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.uniqueName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24">
            <a-form-item label="拟调入所">
              <a-select
                @change="onPlaceChange"
                v-decorator="[
                  'instituteId',
                ]"
                show-search
                :filter-option="$selectFilterOption"
              >
                <a-select-option
                  v-for="item in placeList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24">
            <a-form-item label="拟调入组">
              <a-select
                v-decorator="[
                  'groupId',
                ]"
                show-search
                :filter-option="$selectFilterOption"
              >
                <a-select-option
                  v-for="item in groupList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
        <a-col :lg="24" :md="24" :sm="24" style="margin-top: 16px;padding: 0 100px">
          拟调动人员：
          <a-transfer
            search-placeholder="请输入姓名或部门名称进行搜索"
            :rowKey="(record) => record.id"
            :data-source="list"
            :target-keys="targetKeys"
            :show-search="true"
            :filter-option="filterOption"
            :show-select-all="false"
            @change="onChange"
          >
            <template
              slot="children"
              slot-scope="{
                props: { filteredItems, selectedKeys },
                on: { itemSelectAll, itemSelect },
              }"
            >
              <a-table
                :data-source="filteredItems"
                bordered
                :row-selection="
                  getRowSelection({
                    selectedKeys,
                    itemSelectAll,
                    itemSelect,
                  })
                "
                :pagination="{
                  total: filteredItems.length,
                  showTotal: (total) => `共 ${total} 条记录`,
                }"
              >
                <a-table-column key="name" title="姓名" data-index="name" ellipsis="true" />
                <a-table-column
                  key="mobile"
                  title="手机号"
                  data-index="mobile"
                  ellipsis="true"
                />
                <a-table-column
                  key="deptUniqueName"
                  title="拟调出部门"
                  data-index="deptUniqueName"
                  ellipsis="true"
                />
              </a-table>
            </template>
          </a-transfer>
        
        
        </a-col>
        </a-row>
        <div class="center" style="margin-top: 16px">
          <a-space>
            <a-button type="primary" htmlType="submit" :loading="loading">保存</a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import difference from "lodash/difference";
import organization from "@/mixins/organization";
import { fetchDetailTree } from "@/api/setting/organization";
import request from "@/api/request";

function transfer(data) {
    return request({
        url: '/user-service/talentMap/changeDept',
        method: 'post',
        data,
    })
}

export default {
  name: "transferEmployee",
  mixins: [organization],
  data() {
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      total: 0,
      targetKeys: [], // 穿梭框右侧内容
      placeList: [],
      groupList: [],
      loading: false,
    };
  },
  computed: {
    ...mapState("employeeSelector", [
      "list",
      "recentSelectedList",
      "sortType",
    ]),
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapActions("employeeSelector", ["getList"]),
    filterOption(inputValue, item) {
      return item.name.indexOf(inputValue) !== -1 ||
             (item.deptUniqueName && item.deptUniqueName.indexOf(inputValue) !== -1);
    },
    getRowSelection({ selectedKeys, itemSelectAll, itemSelect }) {
      return {
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          itemSelectAll(diffKeys, selected);
        },

        onSelect({ id }, selected) {
          console.log("onSelect", id, selected);
          itemSelect(id, selected);
        },
        selectedRowKeys: selectedKeys,
      };
    },
    onChange(nextTargetKeys) {
      this.targetKeys = nextTargetKeys;
    },
    handleSubmit(e) {
      if (this.targetKeys.length === 0) {
        this.$message.error("请选择");
        return;
      }
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          transfer({
            deptId: values.deptId,
            instituteId: values.instituteId,
            groupId: values.groupId,
            id: this.targetKeys,
          }).then(() => {
            this.$message.success("保存成功");
            this.$close();
          });
          this.loading = false;
        }
      })
    },
    onDeptChange(id) {
      this.placeList = [];
      this.groupList = [];
      this.form.setFieldsValue({
        instituteId: "",
        groupId: "",
      });
      fetchDetailTree({
        uuid: id,
      }).then((res) => {
        if (res) {
          this.placeList = Array.isArray(res.instituteVoList)
            ? res.instituteVoList
            : [];
        }
      });
    },
    onPlaceChange(value) {
      this.form.setFieldsValue({
        groupId: "",
      });
      const item = this.placeList.find((item) => item.id === value);
      if (item) {
        this.groupList = Array.isArray(item.groupVoList)
          ? item.groupVoList
          : [];
      }
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 0 16px;
}
</style>
